import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  PHONE_NUMBER_TYPES,
  PHONE_NUMBER_TYPE_OPTIONS
} from 'dpl/shared/constants/shared';
import SimpleSelect from 'dpl/form/components/SimpleSelect';
import SimpleTelephoneInput from 'dpl/form/components/SimpleTelephoneInput';
import MultiFieldGroup from 'dpl/form/components/MultiFieldGroup';

export default function SettingsPhoneFields({
  onChange,
  formState,
  formErrors,
  displayErrors,
  formFieldName,
  disableSecondary
}) {
  // initialize newly added number w/ different type from the prev number
  useEffect(() => {
    const phoneNumbers = formState.phone_numbers_attributes || [];
    const newIdx = phoneNumbers.length - 1;

    if (phoneNumbers[newIdx] && phoneNumbers[newIdx].number_type) {
      return;
    }

    const prevType =
      phoneNumbers[newIdx - 1] && phoneNumbers[newIdx - 1].number_type;

    const newType =
      prevType === PHONE_NUMBER_TYPES.MOBILE
        ? PHONE_NUMBER_TYPES.HOME
        : PHONE_NUMBER_TYPES.MOBILE;

    onChange(`phone_numbers_attributes.${newIdx}.number_type`, newType);
  }, [formState.phone_numbers_attributes]);

  return (
    <div className="SettingsPhoneFields">
      <MultiFieldGroup
        name={`${
          formFieldName ? `${formFieldName}.` : ''
        }phone_numbers_attributes`}
        shortLabel="secondary phone number"
        maxAllowed={disableSecondary ? 1 : 2}
      >
        {formState.phone_numbers_attributes?.map(
          (phoneNumber, idx) =>
            !phoneNumber._destroy && (
              <div key={idx} className="row mb6">
                <div className="col-md-6 col-7">
                  <SimpleTelephoneInput
                    displayErrors={displayErrors}
                    errors={
                      formErrors[`phone_numbers_attributes.${idx}.number`]
                    }
                    fullWidth
                    value={formState.phone_numbers_attributes[idx].number}
                    onChange={value => {
                      onChange(`phone_numbers_attributes.${idx}.number`, value);
                    }}
                    label="Phone number"
                    name={`phone_numbers_attributes.${idx}.number`}
                    placeholder="e.g. 555-555-5555"
                    testId="phone-number-input"
                  />
                </div>
                <div className="col-md-6 col-5 nowrap">
                  <SimpleSelect
                    disablePlaceholder
                    value={formState.phone_numbers_attributes[idx].number_type}
                    errors={
                      formErrors[`phone_numbers_attributes.${idx}.number_type`]
                    }
                    onChange={onChange}
                    label="Phone number type"
                    name={`phone_numbers_attributes.${idx}.number_type`}
                    options={PHONE_NUMBER_TYPE_OPTIONS}
                    testId="phone-number-type"
                  />
                </div>
              </div>
            )
        )}
      </MultiFieldGroup>
    </div>
  );
}

SettingsPhoneFields.propTypes = {
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formErrors: PropTypes.object.isRequired,
  displayErrors: PropTypes.bool.isRequired,
  formFieldName: PropTypes.string,
  disableSecondary: PropTypes.bool
};

SettingsPhoneFields.defaultProps = {
  formFieldName: null,
  disableSecondary: false
};
